import React, { useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { LookupCloudAssetItem } from "../../../content-ingestion/common/lookup-cloud-asset/LookupCloudAssetItem";
import { LookupContentItem } from "../../../content-ingestion/common/lookup-content/LookupContentItem";
import { LookupHistoryItem } from "../../../content-ingestion/common/lookup-history/LookupHistoryList";
import { LookupAction, LookupModalManager } from "./LookupModalManager";

export interface LookupActionsButtonProps {
    setContentFromLookupHistory: (item: LookupHistoryItem) => void;
    setContentFromLookupContent: (item: LookupContentItem) => void;
    setContentFromLookupCloudAsset: (item: LookupCloudAssetItem) => void;
}

export const LookupActionsButton = ({
    setContentFromLookupContent,
    setContentFromLookupHistory,
    setContentFromLookupCloudAsset
}: LookupActionsButtonProps): JSX.Element => {
    const [action, setAction] = useState<LookupAction>();
    return (
        <>
            <CommandBarButton
                testId="lookup-actions-button"
                text="Lookups"
                menuItems={[
                    {
                        text: "Lookup history",
                        onClick: () => setAction(LookupAction.LookupHistory)
                    },
                    {
                        text: "Lookup content",
                        onClick: () => setAction(LookupAction.LookupContent)
                    },
                    {
                        text: "Lookup cloud assets",
                        onClick: () => setAction(LookupAction.LookupCloudAssets)
                    }
                ]}
            />
            <LookupModalManager
                onClose={() => setAction(undefined)}
                action={action}
                setContentFromLookupContent={setContentFromLookupContent}
                setContentFromLookupHistory={setContentFromLookupHistory}
                setContentFromLookupCloudAsset={setContentFromLookupCloudAsset}
            />
        </>
    );
};
